// // // BarChart.js
// import React from "react";
// import Chart from "react-apexcharts";
// import useStore from "../../hooks/useStore";
// import GlobalUnitDropDown from "../globalUnitDropDown";
// import {
//   WATER_UNITS_1,
//   WATER_UNITS_2,
//   WATER_INTENSITY,
//   WASTE_UNITS_1,
//   ENERGY_UNITS_1,
//   ENERGY_UNITS_2,
//   ENERGY_UNITS_3,
//   ENERGY_UNITS_4
// } from "../../constants/constants";

// // Mapping for water units (add similar for waste/energy if needed)
// const WATER_UNIT_MAP = {
//   "Kilo Liter": "KL",
//   "Mega liter": "ML",
//   "Meter cube": "M3",
//   "(m3/revenue in ₹Mn)": "[(m3/revenue in ₹Mn)]",
//   "Unit Of Water Intensity in rupees": "Rs",
//   "Unit Of Water Intensity in dollar": "$",
//   "Unit Of Water Intensity in euro": "€"
// };

// const ColumnChart = ({
//   data,
//   categories,
//   hover,
//   title,
//   yaxis,
//   unit,
//   height = "300%", //650 default
//   max,
//   columnWidth,
//   download,
//   heading,
//   label,
//   filterType,
//   currentYear,
//   reportType,
//   ...props
// }) => {
//   const { companyStore } = useStore();
//   //console.log("data",data)
//   const units = Array.isArray(companyStore?.units) ? companyStore.units : [];

//   // Combine all relevant units for the reportType
//   let allUnitNames = [];
//   let mappedShortNames = [];
//   if (reportType === "water") {
//     allUnitNames = [...WATER_UNITS_1, ...WATER_UNITS_2, ...WATER_INTENSITY];
//     mappedShortNames = allUnitNames.map(name => WATER_UNIT_MAP[name]).filter(Boolean);
//   } else if (reportType === "waste") {
//     allUnitNames = [...WASTE_UNITS_1];
//     mappedShortNames = allUnitNames; // If shortName matches constant, use directly
//   } else if (reportType === "energy") {
//     allUnitNames = [
//       ...ENERGY_UNITS_1,
//       ...ENERGY_UNITS_2,
//       ...ENERGY_UNITS_3,
//       ...ENERGY_UNITS_4
//     ];
//     mappedShortNames = allUnitNames; // If shortName matches constant, use directly
//   }

//   // Filter companyStore.units by shortName
//   const unitsToShow = units.filter(u => mappedShortNames.includes(u.shortName));

//   const options = {
//     chart: {
//       type: "bar",
//       height: 350,
//       zoom: {
//         enabled: false,
//       },
//       toolbar: {
//         show: true,
//         offsetY: "100%",
//         offsetX: 0,
//         tools: {
//           download:
//             download === false
//               ? undefined
//               : '<i class="mdi mdi-download" aria-hidden="true" style="font-size: 30px;" ></i>',
//         },
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//         //columnWidth: columnWidth || 35, // earlier it was 20%
//         columnWidth: "50%",
//         endingShape: "rounded",
//         dataLabels: {
//           position: "top", // top, center, bottom
//         },
//       },
//     },
//     dataLabels: {
//       enabled: true,
//       formatter: function (val) {
//         // Show full value, no forced decimals, use locale string for clarity
//         if (val === null || val === undefined) return '';
//         if (Math.abs(val) >= 100) return Number(val).toLocaleString();
//         return Number(val).toFixed(2);
//       },
//       offsetY: -8, // less offset for better placement
//       style: {
//         fontSize: "13px",
//         colors: ["#000"], // black for better contrast
//       },
//     },
//     // colors: ["#556EE6", "#35C38F", "#F46A6A", "#F1B44C"],

//     colors:
//       filterType == "yearly_summary"
//         ? ["#FCD163", "#EF8083"]
//         : [
//             "#FCD163",
//             "#EF8083",
//             "#88BE53",
//             "#46A1E1",
//             "#A889C4",
//             "#FFA07A",
//             "#90EE90",
//             "#87CEEB",
//             "#DDA0DD",
//           ],
//     legend: {
//       show: true,
//       showForSingleSeries: true, // Add this line
//       horizontalAlign: "center",
//       markers: {
//         width: 12,
//         height: 12,
//         radius: 12,
//       },
//       itemMargin: {
//         horizontal: 5,
//         vertical: 5,
//       },
//     },

//     stroke: {
//       show: true,
//       width: 2,
//       colors: ["transparent"],
//     },
//     xaxis: {
//       categories: categories,
//     },
//     annotations: {
//       yaxis,
//     },
//     fill: {
//       opacity: 1,
//     },
//     tooltip: {
//       y: {
//         formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
//           // Console the data prop for this series
//           const seriesData = w.config.series[seriesIndex].data;
//           console.log('[ColumnChart Tooltip] seriesIndex:', seriesIndex, 'dataPointIndex:', dataPointIndex, 'seriesData:', seriesData);
//           // Try to get the unit from the original data array if it was passed as an object
//           let pointUnit = null;
//           if (Array.isArray(seriesData) && seriesData[dataPointIndex] && typeof seriesData[dataPointIndex] === 'object' && 'unit' in seriesData[dataPointIndex]) {
//             pointUnit = seriesData[dataPointIndex].unit;
//           }
//           return `${hover ? hover : ""} ${Number(val).toFixed(2)} ${pointUnit || unit || "N/A"}`;
//         },
//       },
//       // fixed: {
//       //   enabled: true,
//       //   position: "middleRight",
//       // },
//     },
//     yaxis: {
//       ...(max && { max }),
//       min: 0,
//       labels: {
//         formatter: function (val) {
//           return Number(val).toFixed(2);
//         },
//       },
//     },
//     units: { unit },
//   };
//   const series = data || [];
//   return (
//     <div>
//       {/* <div style={{ marginBottom: 16 }}>
//         <span style={{ fontWeight: 600 }}>Unit</span>
//         <select className="form-select" style={{ marginTop: 8 }}>
//           <option value="">Select Unit</option>
//           {unitsToShow.map(unit => (
//             <option key={unit.id} value={unit.id}>{unit.shortName}</option>
//           ))}
//         </select>
//       </div> */}
//       <div id="chart" className="writemode">
//         <div>
//           <h5 className="mb-3 text-muted">
//             {props.heading ? props.heading + " (" + unit + ")" : ""}
//           </h5>
//         </div>
//         <Chart
//           options={options}
//           series={series}
//           type="bar"
//           height={height}
//           unit={unit}
//           {...props}
//         />
//       </div>
//     </div>
//   );
// };

// export default ColumnChart;


// // ColumnChart.js
// // import React from "react";
// // import Chart from "react-apexcharts";

// // const ColumnChart = ({
// //   data,
// //   categories,
// //   hover,
// //   title,
// //   yaxis,
// //   unit,
// //   height = "300%", // Default 650
// //   max,
// //   columnWidth,
// //   download,
// //   heading,
// //   label,
// //   ...props
// // }) => {
// //   const options = {
// //     chart: {
// //       type: "bar",
// //       height: 350,
// //       zoom: { enabled: false },
// //       toolbar: {
// //         show: true,
// //         offsetY: "100%",
// //         offsetX: 0,
// //         tools: {
// //           download:
// //             download === false
// //               ? undefined
// //               : '<i class="mdi mdi-download" aria-hidden="true" style="font-size: 30px;"></i>',
// //         },
// //       },
// //     },
// //     plotOptions: {
// //       bar: {
// //         horizontal: false,
// //         columnWidth: columnWidth || 35,
// //         endingShape: "rounded",
// //         dataLabels: {
// //           position: "top",
// //         },
// //       },
// //     },
// //     dataLabels: {
// //       enabled: true,
// //       formatter: function (val) {
// //         return val;
// //       },
// //       offsetY: -20,
// //       style: {
// //         fontSize: "12px",
// //         colors: ["#304758"],
// //         transform: "rotate(145deg)",
// //       },
// //     },
// //     colors: [
// //       "#FCD163",
// //       "#EF8083",
// //       "#88BE53",
// //       "#46A1E1",
// //       "#A889C4",
// //       "#FFA07A",
// //       "#90EE90",
// //       "#87CEEB",
// //       "#DDA0DD",
// //     ],
// //     legend: {
// //       show: true,
// //       showForSingleSeries: false,
// //       position: "top",
// //       horizontalAlign: "center",
// //       floating: false,
// //       offsetY: 0,
// //       labels: {
// //         useSeriesColors: false,
// //       },
// //       markers: {
// //         width: 12,
// //         height: 12,
// //         radius: 12,
// //       },
// //       itemMargin: {
// //         horizontal: 8,
// //         vertical: 4,
// //       },
// //     },
// //     stroke: {
// //       show: true,
// //       width: 2,
// //       colors: ["transparent"],
// //     },
// //     xaxis: {
// //       categories: categories,
// //     },
// //     annotations: {
// //       yaxis,
// //     },
// //     fill: {
// //       opacity: 1,
// //     },
// //     tooltip: {
// //       y: {
// //         formatter: function (val, { series, seriesIndex, dataPointIndex, w }) {
// //           const year = w.globals.seriesNames[seriesIndex];
// //           return `${year}: ${val} ${unit || "N/A"}`;
// //         },
// //       },
// //     },
// //     yaxis: {
// //       ...(max && { max }),
// //       min: 0,
// //     },
// //     units: { unit },
// //   };

// //   const series = data || [];

// //   return (
// //     <div id="chart" className="writemode">
// //       <div>
// //         <h5 className="mb-3 text-muted">
// //           {heading ? `${heading} (${unit})` : ""}
// //         </h5>
// //       </div>
// //       <Chart
// //         options={options}
// //         series={series}
// //         type="bar"
// //         height={height}
// //         unit={unit}
// //         {...props}
// //       />
// //     </div>
// //   );
// // };

// // export default ColumnChart;






//the old one
// import React from "react";
// import Chart from "react-apexcharts";

// const ColumnChart = ({
//   data,
//   categories,
//   hover,
//   title,
//   yaxis,
//   unit,
//   height = "300%",
//   max,
//   columnWidth,
//   download,
//   heading,
//   label,
//   filterType,
//   currentYear,
//   reportType,
//   ...props
// }) => {
//   // ✅ Add logging to see what data is received by ColumnChart
  

//   const options = {
//     chart: {
//       type: "bar",
//       height: 350,
//       zoom: {
//         enabled: false,
//       },
//       toolbar: {
//         show: true,
//         offsetY: "100%",
//         offsetX: 0,
//         tools: {
//           download:
//             download === false
//               ? undefined
//               : '<i class="mdi mdi-download" aria-hidden="true" style="font-size: 30px;" ></i>',
//         },
//       },
//     },
//     plotOptions: {
//       bar: {
//         horizontal: false,
//         columnWidth: "50%",
//         endingShape: "rounded",
//         dataLabels: {
//           position: "top",
//         },
//       },
//     },
//     dataLabels: {
//       enabled: true,
//       formatter: function (val) {
//         if (val === null || val === undefined) return '';
//         if (Math.abs(val) >= 100) return Number(val).toLocaleString();
//         return Number(val).toFixed(2);
//       },
//       offsetY: -8,
//       style: {
//         fontSize: "13px",
//         colors: ["#000"],
//       },
//     },
//     colors:
//       filterType == "yearly_summary"
//         ? ["#FCD163", "#EF8083"]
//         : [
//             "#FCD163",
//             "#EF8083",
//             "#88BE53",
//             "#46A1E1",
//             "#A889C4",
//             "#FFA07A",
//             "#90EE90",
//             "#87CEEB",
//             "#DDA0DD",
//           ],
//     legend: {
//       show: true,
//       showForSingleSeries: true,
//       horizontalAlign: "center",
//       markers: {
//         width: 12,
//         height: 12,
//         radius: 12,
//       },
//       itemMargin: {
//         horizontal: 5,
//         vertical: 5,
//       },
//     },
//     stroke: {
//       show: true,
//       width: 2,
//       colors: ["transparent"],
//     },
//     xaxis: {
//       categories: categories,
//     },
//     annotations: {
//       yaxis,
//     },
//     fill: {
//       opacity: 1,
//     },
//     tooltip: {
//       y: {
//         formatter: function (val, { seriesIndex, dataPointIndex }) {
//           // Debug logs to trace unit selection
//           // console.log('[Tooltip Debug] seriesIndex:', seriesIndex, 'dataPointIndex:', dataPointIndex);
//           const originalSeries = data[seriesIndex];
//           //console.log('[Tooltip Debug] originalSeries:', originalSeries);
//           let pointUnit = unit;
//           if (originalSeries && originalSeries.units) {
//             console.log('[Tooltip Debug] originalSeries.units:', originalSeries.units);
//             console.log('[Tooltip Debug] originalSeries.units[dataPointIndex]:', originalSeries.units[dataPointIndex]);
//             if (originalSeries.units[dataPointIndex] !== undefined && originalSeries.units[dataPointIndex] !== null) {
//               pointUnit = originalSeries.units[dataPointIndex];
//               console.log('[Tooltip Debug] Picked unit from units array:', pointUnit);
//             } else if (originalSeries.units.length > 0) {
//               pointUnit = originalSeries.units[originalSeries.units.length - 1];
//               console.log('[Tooltip Debug] Fallback to last unit in array:', pointUnit);
//             }
//           }
//           // Fallback: Try to get unit from data point object if available
//           if ((!pointUnit || pointUnit === undefined) && originalSeries && originalSeries.data && Array.isArray(originalSeries.data)) {
//             const dataPoint = originalSeries.data[dataPointIndex];
//             console.log('[Tooltip Debug] dataPoint:', dataPoint);
//             if (dataPoint && typeof dataPoint === 'object' && dataPoint.unit) {
//               pointUnit = dataPoint.unit;
//               console.log('[Tooltip Debug] Picked unit from data point object:', pointUnit);
//             }
//           }
//           console.log('[Tooltip Debug] Final pointUnit:', pointUnit);
//           return `${hover ? hover + ": " : ""}${Number(val).toFixed(2)} ${pointUnit || ''}`;
//         },
//       },
//     },
//     yaxis: {
//       ...(max && { max }),
//       min: 0,
//       labels: {
//         formatter: function (val) {
//           return Number(val).toFixed(2);
//         },
//       },
//     },
//   };

//   // Transform data to ensure ApexCharts gets the right format
//   const series = (data || []).map(item => ({
//     name: item.name,
//     // Extract just the values for ApexCharts, but preserve original data structure
//     data: Array.isArray(item.data) 
//       ? item.data.map(d => typeof d === 'object' ? d.value : d)
//       : [],
//   }));

//   return (
//     <div>
//       <div id="chart" className="writemode">
//         <div>
//           <h5 className="mb-3 text-muted">
//             {props.heading ? props.heading + " (" + unit + ")" : ""}
//           </h5>
//         </div>
//         <Chart
//           key={filterType + JSON.stringify(data)}
//           options={options}
//           series={series}
//           type="bar"
//           height={height}
//           {...props}
//         />
//       </div>
//     </div>
//   );
// };



// export default ColumnChart;



//correct new one


import React from "react";
import Chart from "react-apexcharts";

const ColumnChart = ({
  data,
  categories,
  hover,
  title,
  yaxis,
  unit,
  // ✅ Use a numeric height (px). Percent heights can trigger getComputedStyle errors.
  height = 450,
  max,
  columnWidth,
  download,
  heading,
  label,
  filterType,
  currentYear,
  reportType,
  ...props
}) => {
  // ✅ Render only after mount to avoid getComputedStyle on a non-Element during hydration/strict mode
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);

  const options = {
    chart: {
      type: "bar",
      height: 350,
      zoom: { enabled: false },
      toolbar: {
        show: true,
        // ✅ Must be a number, not "100%"
        offsetY: "100%",
        offsetX: 0,
        tools: {
          download:
            download === false
              ? undefined
              : '<i class="mdi mdi-download" aria-hidden="true" style="font-size: 30px;" ></i>',
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        endingShape: "rounded",
        dataLabels: { position: "top" },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        if (val === null || val === undefined) return "";
        if (Math.abs(val) >= 100) return Number(val).toLocaleString();
        return Number(val).toFixed(2);
      },
      offsetY: -8,
      style: { fontSize: "13px", colors: ["#000"] },
    },
    colors:
      filterType == "yearly_summary"
        ? ["#FCD163", "#EF8083"]
        : ["#FCD163", "#EF8083", "#88BE53", "#46A1E1", "#A889C4", "#FFA07A", "#90EE90", "#87CEEB", "#DDA0DD"],
    legend: {
      show: true,
      showForSingleSeries: true,
      horizontalAlign: "center",
      markers: { width: 12, height: 12, radius: 12 },
      itemMargin: { horizontal: 5, vertical: 5 },
    },
    stroke: { show: true, width: 2, colors: ["transparent"] },
    xaxis: { categories: categories },
    annotations: { yaxis },
    fill: { opacity: 1 },
    tooltip: {
      y: {
        formatter: function (val, { seriesIndex, dataPointIndex }) {
          const originalSeries = data[seriesIndex];
          let pointUnit = unit;
          if (originalSeries && originalSeries.units) {
            if (
              originalSeries.units[dataPointIndex] !== undefined &&
              originalSeries.units[dataPointIndex] !== null
            ) {
              pointUnit = originalSeries.units[dataPointIndex];
            } else if (originalSeries.units.length > 0) {
              pointUnit = originalSeries.units[originalSeries.units.length - 1];
            }
          }
          if (
            (!pointUnit || pointUnit === undefined) &&
            originalSeries &&
            originalSeries.data &&
            Array.isArray(originalSeries.data)
          ) {
            const dataPoint = originalSeries.data[dataPointIndex];
            if (dataPoint && typeof dataPoint === "object" && dataPoint.unit) {
              pointUnit = dataPoint.unit;
            }
          }
          return `${hover ? hover + ": " : ""}${Number(val).toFixed(2)} ${pointUnit || ""}`;
        },
      },
      
    },
    yaxis: {
      ...(max && { max }),
      min: 0,
       tickAmount: 10,
      labels: {
        formatter: function (val) {
          return Number(val).toFixed(2);
        },
      },
    },
  };

  const series = (data || []).map((item) => ({
    name: item.name,
    data: Array.isArray(item.data)
      ? item.data.map((d) => (typeof d === "object" ? d.value : d))
      : [],
  }));

  return (
    <div>
      <div id="chart" className="writemode" style={{ marginBottom: "32px" }}>
        <div>
          <h5 className="mb-3 text-muted">
            {props.heading ? props.heading + " (" + unit + ")" : ""}
          </h5>
        </div>
        {mounted && (
          <Chart
            key={filterType + JSON.stringify(data)}
            options={options}
            series={series}
            type="bar"
            height={height}
            parentHeightOffset={80}
            {...props}
          />
        )}
      </div>
    </div>
  );
};

export default ColumnChart;


//newone
